import { Components, Theme } from '@mui/material'

export const MuiDivider: Components<Omit<Theme, 'components'>>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.border.strong,
    }),
  },
  variants: [
    {
      props: { orientation: 'vertical' },
      style: ({ theme }) => ({
        borderRightWidth: theme.strokeWidth.default,
      }),
    },
    {
      props: { orientation: 'horizontal' },
      style: ({ theme }) => ({
        borderBottomWidth: theme.strokeWidth.default,
      }),
    },
  ],
}
